export const MAINTENANCE_TYPE = {
  NONE: 'maintenance-none',
  NO_CAPABILITIES_DISRUPTION: 'no-disruption',
  WITH_CAPABILITIES_DISRUPTION: 'with-disruption'
};
export const MAINTENANCE_STATE = {
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in-progress'
};
export const MAINTENANCE_BANNER_TARGET_PAGES = {
  ALL: 'all',
  MARKETPLACE_PARTNER_PORTAL: 'marketplace-partner-portal'
};
export const MaintenanceNone = {
  type: MAINTENANCE_TYPE.NONE,
  content: ''
};